import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Concatenates conditional class names and dedupes Tailwind utilities so the
 * last-wins rule is preserved. Standard helper used by every shadcn primitive.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
